import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';

const ReturnPolicy = () => {
  return (
    <section className="ec-page-content py-5 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center mb-5">
            <div className="section-title">
              
              <h2 className="fw-bold text-dark animate__animated animate__fadeInUp">Return Policy</h2>
            </div>
          </div>

          <div className="col-md-12">
            <div className="p-4 bg-white rounded shadow-sm animate__animated animate__fadeIn">
              <p className="lead text-secondary">
                At <strong>EESOUQ</strong>, we strive to ensure your satisfaction with every purchase. Our Returns Policy is designed
                to provide you with clarity and convenience in case you need to return a product. Please take a moment to
                familiarize yourself with our conditions and procedures:
              </p>

              <div className="mb-4">
                <h4 className="text-info">1. Return Possibilities</h4>
                <ul className="ms-3">
                  <li>You have received the wrong product.</li>
                  <li>The product received is not as described on the site.</li>
                  <li>You have received a damaged product.</li>
                </ul>
                <p className="text-success">Yes, returns are possible under these conditions.</p>

                <h5 className="text-warning mt-3">Special Note for Refurbished Products</h5>
                <p>
                  Refurbished items must be returned within seven (7) days of receipt of shipment, and they should be
                  unused, in the original unbroken packaging, and include all tags. For electronics, open products will be
                  accepted only if they differ from the description or picture displayed.
                </p>
              </div>

              <div className="mb-4">
                <h4 className="text-info">2. Change of Mind</h4>
                <p>
                  Returns are accepted in specific conditions as outlined in our Returns Policy. You have the right to
                  return a product within fifteen (15) days of receiving the shipment.
                </p>

                <h5 className="text-warning">Special Note for Refurbished Products</h5>
                <p>
                  Refurbished items must be returned within seven (7) days of receipt of shipment, and returns are subject
                  to category-specific terms and conditions found in our Returns Policy.
                </p>

                <h5 className="text-danger">Non-Returnable Products</h5>
                <p>
                  Certain products cannot be returned, replaced, or exchanged. These include hazardous materials, products
                  with flammable liquids or gases, used or damaged items, consumables, products with tampered or missing
                  serial numbers, and specific categories like food, beverages, clothing, hygiene-related items, and more.
                </p>

                <h5 className="text-primary">Contacting Us for Returns</h5>
                <p>Reach out to us by visiting the 'Account' section and clicking on 'Contact Us.'</p>
              </div>

              <div className="mb-4">
                <h4 className="text-info">Your Refund</h4>
                <p>
                  For delivered products, a refund of the product amount (excluding original shipping fees) will be issued
                  if the products are faulty or not as described on our site, or if the return is due to an error on our
                  side. In other circumstances, the product amount (excluding shipping fees) will be refunded, and you may
                  cover return shipping. No refunds for accidental damage.
                </p>
                <p>
                  Note: Refund is only applicable if you are sending a request within 10 to 15 days of delivery. If you
                  receive a damaged box or seal, you can return it or ask for a refund only if the box and seal are not
                  opened.
                </p>

                <h5 className="text-success">Refund Procedure</h5>
                <ul className="ms-3">
                  <li>If paid by Cash on Delivery, a refund will be issued to your wallet.</li>
                </ul>

                <h5 className="text-success">Refund Timescale</h5>
                <ul className="ms-3">
                  <li>Card refunds: within 30 days after receiving the product.</li>
                  <li>Pre-shipping cancellations: automatic refund is provided.</li>
                </ul>
              </div>

              <div className="text-center mt-4">
                <p className="text-muted">
                  At <strong>EESOUQ</strong>, we are committed to ensuring a seamless and transparent returns process. Your satisfaction is
                  our priority. If you have any concerns, reach out via the 'Contact Us' section in your account. <br />
                  <span className="fw-bold text-primary">Happy shopping!</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReturnPolicy;
